<app-common-header-layout
  [showHeaderCta]="true"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject$ | async"
>
  <app-heading
    [title]="'SET_PASSWORD.TITLE' | translate"
    [subtitle]="'SET_PASSWORD.SUBTITLE_MESSAGE' | translate"
    [hasLessMargin]="!!(error$ | async)"
  >
  </app-heading>

  <div class="form-body">
    <app-form-banner
      *ngIf="error$ | async as message"
      [message]="message"
      bannerStyle="error"
    ></app-form-banner>

    <app-set-password-form
      [trackingObject]="trackingObject$ | async"
      [trackingAction]="setPasswordAction"
      (buttonSubmit)="setPassword($event.password)"
    >
    </app-set-password-form>
  </div>

  <i2g-full-screen-spinner
    [show]="processing$ | async"
  ></i2g-full-screen-spinner>
</app-common-header-layout>
